import React from 'react'
import { Check } from 'lucide-react'
import Reveal3 from '@/components/marketing3/Reveal3'
import PhoneMockup from '@/components/marketing3/widgets/PhoneMockup'

/**
 * MobileApp3 — light, standalone section, promoted from its v1/v2 afterthought card.
 * H2 "Your revenue, in your pocket." + four value-prop bullets + the PhoneMockup (W11).
 *
 * Copy quoted VERBATIM from docs/marketing/2026-07-05-landing3-copy.md §Mobile. Per
 * plan §2.8 / §0, "Coming soon" is a small mono chip on the phone frame (rendered by
 * PhoneMockup) — NOT the headline, NOT the body. This section's prose carries none of
 * it. No PMS name, no stage counts, no cadence anywhere.
 */

const BULLETS = [
  'Today’s prices and pickup at a glance.',
  'Approve an agent’s plan from anywhere.',
  'Nudge a night from the corridor, not the back office.',
  'Alerts only when something needs you.',
]

export default function MobileApp3({ brand }: { brand: string }) {
  return (
    <section id="mobile" aria-label={`The ${brand} mobile app`}>
      <div className="mx-auto max-w-6xl px-4 py-24 sm:px-6 sm:py-28">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
          {/* Prose column */}
          <Reveal3>
            <p className="mkt3-eyebrow">Mobile</p>
            <h2 className="mkt3-display mkt3-h2 mt-4">Your revenue, in your pocket.</h2>

            <ul className="mt-8 space-y-4">
              {BULLETS.map((bullet) => (
                <li key={bullet} className="flex items-start gap-3">
                  <span
                    aria-hidden="true"
                    className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-50 text-teal-700 ring-1 ring-inset ring-teal-600/15"
                  >
                    <Check className="h-3 w-3" strokeWidth={2.5} />
                  </span>
                  <span className="mkt3-prose">{bullet}</span>
                </li>
              ))}
            </ul>
          </Reveal3>

          {/* The phone mockup */}
          <Reveal3 delay={80} className="flex justify-center lg:justify-end">
            <PhoneMockup brand={brand} />
          </Reveal3>
        </div>
      </div>
    </section>
  )
}
